module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "max-height": "100%",
      "width": "auto",
      "max-width": "100%",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "image",
      "src": "images/129_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chaptersubtitle"
  }, [_vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "extra-indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v(" s a pastor of four Baptist churches for a total of forty-three (43) years, I have seen a lot of people whose lives are a testimony of God's power bringing triumph out of tragedy; people whose wounds become a witness to God's grace and power. Boyd Chisum is one of the people at the top of the list.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In “I'll Run With You,” Boyd bears indisputable testimony to the truth that circumstances and events can be overcome; that difficulty doesn't mean defeat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To anyone who's read Boyd's first book, “"), _c('i', [_vm._v("Chasing The Wind")]), _vm._v(",” and thought that his faith in and faithfulness to God would grow weaker as his circumstances continued to be painful, here is his witness that his faith is strong and his hope is brighter than ever. In the scripture we are promised that God's grace is sufficient (2 Corinthians 12:9), that He will never allow His own to be tempted, tried and tested beyond our strength in Him (1 Corinthians 10:13). Scripture also reveals the one pursuit that every believer is to be engaged in: “"), _c('i', [_vm._v("You will be my witnesses")]), _vm._v(",” (Acts 1:8). A witness is someone who speaks what they have personally observed or experienced. “"), _c('i', [_vm._v("I'll Run With You")]), _vm._v(",” is a witness to God's Grace Saving us from sin, His Power Sufficient to carry us through hardships, and His giving us a Soaring Hope of complete deliverance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your affliction may be different from Boyd's, Lacee's or Myrtle's, but God's promise is the same: “"), _c('i', [_vm._v("These light afflictions…are not worthy to be compared to the glory that will be revealed in us")]), _vm._v(".” (2 Corinthians 4: 17)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Read and experience the pain, see the hope and expect the fulfillment of God's promise—“"), _c('i', [_vm._v("He will wipe away every tear from their eyes. Death will exist no longer; grief, crying, and pain will exist no longer because the previous things have passed away (Revelation 21:4)")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boyd, Lacee, Myrtle and All of God's Children, “"), _c('i', [_vm._v("I'll Run With You, too!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roy Ford")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pastor, First Baptist Church")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hooks, Texas")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c77beda6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ford.vue
// module id = 75
// module chunks = 0